<itl-wizard-page
  *ngIf="form"
  pageTitleTransPath="serviceOrder.detail.setMedicalOrderRequestStatus"
  [isSinglePage]="true"
  [pageIsValid]="form.valid"
  (doneClicked)="save()"
  (cancelClicked)="cancel()"
>
  <itl-info-box *ngFor="let error of form.errors | keys" [type]="warningType">
    {{ 'validation.errors.' + error | translate }}</itl-info-box
  >
  <itl-selection
    [title]="'serviceOrder.detail.medicalOrderRequestStatus' | translate"
    [(ngModel)]="medicalOrderRequestStatus"
    [values]="medicalOrderRequestStatusTypes"
    [formControl]="medicalOrderRequestStatusType"
    icon="alberta-status"
    [required]="true"
  ></itl-selection>
</itl-wizard-page>
